import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Promo codes: the list, and one code's page. */
export const Route = createFileRoute("/_app/growth/promo-codes")({
  component: Outlet,
});
